const React = require('react');

/* eslint-disable */
module.exports = (props) => {
  return (
    <svg
      viewBox="0 0 300 300"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={`dB w36 ` + (props.className || '')}
    >
      <defs>
        <linearGradient id="linearGradient2319" x1="-1.0001" x2="1355.9" y1="733.15" y2="733.15"
                        gradientTransform="matrix(.033121 0 0 .033121 1401.2 -50.62)" gradientUnits="userSpaceOnUse">
          <stop offset="0"></stop>
          <stop stopColor="#595959" offset="1"></stop>
        </linearGradient>
        <linearGradient id="linearGradient2337" x1="-524.64" x2="-299.45" y1="349.59" y2="553.22"
                        gradientTransform="matrix(.035882 0 0 .035882 46.851 1395.8)" gradientUnits="userSpaceOnUse">
          <stop stopColor="#e53213" offset="0"></stop>
          <stop stopColor="#e94e90" offset="1"></stop>
        </linearGradient>
        <filter id="filter6905" x="-.48" y="-.48" width="1.96" height="1.96" colorInterpolationFilters="sRGB">
          <feGaussianBlur stdDeviation="97.338955"></feGaussianBlur>
        </filter>
        <filter id="filter7264" x="-.4848" y="-.4848" width="1.9696" height="1.9696" colorInterpolationFilters="sRGB">
          <feGaussianBlur stdDeviation="98.312348"></feGaussianBlur>
        </filter>
      </defs>
      <g transform="matrix(6.634 0 0 6.634 -24.72 -9295.6)">
        <rect transform="rotate(90)" x="1401.2" y="-48.948" width="45.222" height="45.222" ry="8.2804"
              fill="url(#linearGradient2319)" fillRule="evenodd" style={{paintOrder: 'markers fill stroke'}}></rect>
        <circle transform="matrix(.014467 0 0 .014467 38.066 1406)" cx="-385.7" cy="452.6" r="243.35" fillOpacity="0"
                filter="url(#filter7264)" stroke="#090000" strokeLinecap="round" strokeLinejoin="round"
                strokeWidth="169.78" style={{paintOrder: 'markers fill stroke'}}></circle>
        <circle cx="31.98" cy="1411.8" r="5.1575" fill="url(#linearGradient2337)" fillRule="evenodd"
                style={{paintOrder: 'markers fill stroke'}}></circle>
        <circle transform="matrix(.034309 0 0 .029632 51.404 1403.5)" cx="-660.08" cy="972.25" r="243.35"
                fillOpacity="0" filter="url(#filter6905)" stroke="#090000" strokeLinecap="round"
                strokeLinejoin="round" strokeWidth="169.78" style={{paintOrder: 'markers fill stroke'}}></circle>
        <rect x="15.348" y="1408.3" width="5.6568" height="22.19" fill="#fff" fillRule="evenodd"
              style={{paintOrder: 'markers fill stroke'}}></rect>
        <circle cx="26.222" cy="1430" r="8.06" fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round"
                strokeWidth="5.6233" style={{paintOrder: 'markers fill stroke'}} />
      </g>
    </svg>
  );
};
